import { ConcreteEncodable } from "./ConcreteEncodable";

import { TenorToValueDateImplEncoder } from "../../encoder/TenorToValueDateImplEncoder";

import * as CubiqTS from "../../index";
import { TenorToValueDate } from "../TenorToValueDate";

export class TenorToValueDateImpl extends ConcreteEncodable implements TenorToValueDate {
  public static enType: string = "com.bcdfx.model.calendar.TenorToValueDateImpl";

  /*FID=1*/
  public tenor: CubiqTS.Tenor;
  /*FID=2*/
  public valueDate: CubiqTS.StandardDate | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = TenorToValueDateImplEncoder.Instance;
    this.setEncodableType(TenorToValueDateImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "TenorToValueDateImpl[" +
      "tenor=" +
      this.tenor +
      "valueDate=" +
      this.valueDate +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
